var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabRecents = function SvgTabRecents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_1",
    transform: "translate(-52.000000, -623.000000)",
    fill: "#ACC0D2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(39.000000, 623.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2802734,13.6551797 C26.1340234,13.8014297 25.9420352,13.8750469 25.7500469,13.8750469 C25.5580586,13.8750469 25.3659297,13.8014297 25.2198203,13.6551797 L21.4697734,9.90527344 C21.3287266,9.76507031 21.2500469,9.57445312 21.2500469,9.37504687 L21.2500469,4.5 C21.2500469,4.08526172 21.5859648,3.75004687 22,3.75004687 C22.4140352,3.75004687 22.7499531,4.08526172 22.7499531,4.5 L22.7499531,9.06454687 L26.2802734,12.5947266 C26.5734766,12.8880703 26.5734766,13.3619766 26.2802734,13.6551797 M22,0 C17.0372031,0 13,4.03720313 13,9 C13,13.9627969 17.0372031,18 22,18 C26.9627969,18 31,13.9627969 31,9 C31,4.03720313 26.9627969,0 22,0",
    id: "Fill-1"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabRecents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tab_recents.dfdf4df6.svg";
export { ForwardRef as ReactComponent };